import React from 'react';
import {translate} from '../../utils/localization-utils';
import SubtitleArrowIcon from '../../../../assets/img/icons/SubtitleArrowIcon';

interface TitleProps {
	keyValue: string;
	customClass?: string;
}

export default function SubTitle({ keyValue, customClass }: TitleProps) {
	return (
		<div className='w-full relative flex items-center gap-2 mb-[20px] mt-[30px] pb-[6px] after:absolute after:bottom-0 after:left-0 after:right-0 after:border after:border-blue'>
			<SubtitleArrowIcon />
			<h2 className={`text-[16px] text-blue ${customClass}`}>{translate(keyValue)}</h2>
		</div>
	);
}
